import { FC, useEffect, useState } from 'react'
import gql from 'graphql-tag'
import styled, { css } from 'styled-components'
import {
  CategoryActivityType,
  useScreenJobCategoryQuery,
} from 'generated/graphql'
import FirstCategories from '../component/FirstCategories'
import SecondCategories from '../component/SecondCategories'
import ThirdCategories from '../component/ThirdCategories'
import useJobCategoryStore from '../store/store.jobCategory'

gql`
  query ScreenJobCategory($filterBy: CategoryFilter) {
    categories(filterBy: $filterBy) {
      ...StoreJobCategoryRoot_category
    }
  }
`

interface IFScreenJobCategoryProps {
  defaultCategoryIds?: string[]
  className?: string
}

const ScreenJobCategory: FC<IFScreenJobCategoryProps> = ({
  defaultCategoryIds,
  className,
}) => {
  const initCategories = useJobCategoryStore((state) => state.initCategories)
  const resetState = useJobCategoryStore((state) => state.resetState)

  const [firstLoading, setFirstLoading] = useState<boolean>(true)

  const { data, loading } = useScreenJobCategoryQuery({
    variables: {
      filterBy: {
        activityType: CategoryActivityType.RECRUIT,
        parentId: null,
      },
    },
    onCompleted: () => {
      setFirstLoading(false)
    },
    notifyOnNetworkStatusChange: true,
  })

  useEffect(() => {
    resetState()
    if (data?.categories) {
      const validCategories = data.categories.filter(
        (category) => category !== null,
      )
      initCategories(validCategories, defaultCategoryIds)
    }
  }, [data])

  return (
    <StyledWrapper className={className}>
      {loading || firstLoading ? (
        'loading'
      ) : (
        <>
          <FirstCategories className="group-categories fixed-scrollbar" />
          <SecondCategories className="group-categories fixed-scrollbar" />
          <ThirdCategories className="item-categories fixed-scrollbar" />
        </>
      )}
    </StyledWrapper>
  )
}

export default ScreenJobCategory

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    border: 1px solid ${theme.line.line_2};
    width: 100%;
    height: 335px;

    > *:not(:last-child) {
      border-right: 1px solid ${theme.line.line_2};
    }

    .group-categories {
      width: 200px;
    }
    .item-categories {
      flex: 1;
    }

    .fixed-scrollbar {
      scrollbar-width: thin;
      scrollbar-color: #ebebeb #ffffff00;

      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        background: #ffffff00;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: #ebebeb;
      }
    }
  `}
`
